/*!
 * ignore
 */

'use strict';

module.exports = function() {};



//////////////////
// WEBPACK FOOTER
// ./~/mongoose/lib/drivers/browser/ReadPreference.js
// module id = 358
// module chunks = 0